/* Win Motoring theme — carousels, gallery, drawers, collection toolbar */
(function () {
  'use strict';

  /* ---------- Carousel prev/next buttons ---------- */
  document.querySelectorAll('[data-carousel-controls]').forEach(function (controls) {
    var section = controls.closest('.section') || controls.closest('section');
    var track = section ? section.querySelector('[data-carousel]') : null;
    if (!track) return;

    var prev = controls.querySelector('[data-prev]');
    var next = controls.querySelector('[data-next]');

    function step() {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    var motionOK = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: motionOK ? 'smooth' : 'auto' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: motionOK ? 'smooth' : 'auto' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Product gallery thumbnails ---------- */
  var mainImg = document.getElementById('GalleryMainImg');
  if (mainImg) {
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    thumbs.forEach(function (thumb, i) {
      if (i === 0) thumb.classList.add('is-active');
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.dataset.full;
        mainImg.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Per-wheel quantity hint (products priced each) ---------- */
  var qtyTotal = document.getElementById('QtyTotal');
  var qtyInput = document.getElementById('Quantity');
  if (qtyTotal && qtyInput) {
    var unitPrice = parseInt(qtyTotal.dataset.unitPrice, 10);
    var money = function (cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    qtyInput.addEventListener('input', function () {
      var n = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyTotal.textContent = n === 4
        ? 'Set of 4 — ' + money(unitPrice * 4)
        : n + (n === 1 ? ' wheel — ' : ' wheels — ') + money(unitPrice * n) + (n === 1 ? '. Most cars need 4.' : '');
    });
  }

  /* ---------- Cart: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Collection toolbar ---------- */
  var toolbar = document.querySelector('[data-collection-toolbar]');
  if (toolbar) {
    var baseUrl = toolbar.dataset.collectionUrl;
    var fitmentTag = toolbar.dataset.fitmentTag || '';
    var view = toolbar.dataset.view || '';

    function navigate(brand, sort) {
      var tags = [fitmentTag, brand].filter(Boolean);
      var url = baseUrl + (tags.length ? '/' + tags.join('+') : '');
      var params = new URLSearchParams();
      if (sort) params.set('sort_by', sort);
      if (view) params.set('view', view);
      var qs = params.toString();
      location.href = url + (qs ? '?' + qs : '');
    }

    var sortSel = toolbar.querySelector('[data-sort-select]');
    var brandSel = toolbar.querySelector('[data-brand-select]');
    var currentBrand = brandSel ? brandSel.value : '';
    var currentSort = new URLSearchParams(location.search).get('sort_by') || '';

    if (sortSel) sortSel.addEventListener('change', function () {
      navigate(currentBrand, sortSel.value);
    });
    if (brandSel) brandSel.addEventListener('change', function () {
      navigate(brandSel.value, currentSort);
    });

    /* Price filter runs client-side over the rendered grid */
    var priceSel = toolbar.querySelector('[data-price-select]');
    var grid = document.querySelector('[data-product-grid]');
    if (priceSel && grid) {
      var countLabel = toolbar.querySelector('[data-count-label]');
      var emptyNote = document.querySelector('[data-filter-empty]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
      var total = cards.length;

      function applyPrice(range) {
        var min = 0, max = Infinity;
        if (range) {
          var parts = range.split('-');
          min = (parseFloat(parts[0]) || 0) * 100;
          max = parts[1] ? parseFloat(parts[1]) * 100 : Infinity;
        }
        var shown = 0;
        cards.forEach(function (card) {
          var p = parseInt(card.dataset.price, 10);
          var ok = !range || (p >= min && p < max);
          card.hidden = !ok;
          if (ok) shown++;
        });
        if (countLabel) {
          countLabel.textContent = range
            ? shown + ' of ' + total + (total === 1 ? ' product' : ' products')
            : total + (total === 1 ? ' product' : ' products');
        }
        if (emptyNote) emptyNote.hidden = shown > 0;
        var params = new URLSearchParams(location.search);
        if (range) params.set('price', range); else params.delete('price');
        var qs = params.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
      }

      priceSel.addEventListener('change', function () { applyPrice(priceSel.value); });
      var initial = new URLSearchParams(location.search).get('price');
      if (initial) { priceSel.value = initial; applyPrice(initial); }
    }
  }

  /* ---------- Vehicle / bolt jump selects ---------- */
  document.querySelectorAll('[data-tag-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var base = sel.dataset.baseUrl;
      location.href = sel.value ? base + '/' + sel.value : base;
    });
  });

  /* ---------- Drawers: pin mobile menu below header, close on Esc/outside ---------- */
  var drawerToggle = document.getElementById('MenuDrawer');
  if (drawerToggle) drawerToggle.addEventListener('toggle', function () {
    var header = document.querySelector('.site-header');
    var drawer = drawerToggle.querySelector('.menu-drawer');
    if (header && drawer) drawer.style.top = header.getBoundingClientRect().bottom + 'px';
  });

  function closeDrawers(except) {
    ['MenuDrawer', 'SearchDrawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el !== except) el.removeAttribute('open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });
  document.addEventListener('click', function (e) {
    var inDrawer = e.target.closest('#MenuDrawer, #SearchDrawer');
    if (!inDrawer) closeDrawers();
    else closeDrawers(inDrawer);
  });
})();
